// src/components/mask/CpfInput.tsx
import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

interface CpfInputProps extends Omit<TextFieldProps, 'onChange'> {
    value: string;
    onChange: (value: string) => void;
    label?: string;
}

const CpfInput: React.FC<CpfInputProps> = ({
    value,
    onChange,
    label = 'CPF',
    ...props
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // só números, máximo 11 dígitos
        const digits = e.target.value.replace(/\D/g, '').slice(0, 11);

        // formata como 000.000.000-00
        const formatted = digits.replace(
            /^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2}).*$/,
            (_m, g1, g2, g3, g4) =>
                (g1 || '') +
                (g2 ? `.${g2}` : '') +
                (g3 ? `.${g3}` : '') +
                (g4 ? `-${g4}` : '')
        );

        onChange(formatted);
    };

    return (
        <TextField
            {...props}
            label={label}
            value={value}
            onChange={handleChange}
            inputProps={{ maxLength: 14 }}  // CPF formatado tem até 14 chars: 000.000.000-00
            fullWidth
        />
    );
};

export default CpfInput;
